module.exports = __webpack_public_path__ + "static/media/clipping_mask.vertex.8ade77f8.glsl";